export default {
  buttonSelect: {
    label: 'Selezionare'
  }
}
